import { render } from "./dashboard-teacher.vue?vue&type=template&id=e65d0e38&ts=true"
import script from "./dashboard-teacher.vue?vue&type=script&lang=ts"
export * from "./dashboard-teacher.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__